// extracted by mini-css-extract-plugin
module.exports = {"PropHeader":"ServerSettings_PropHeader__3YvwD","SettingsFooter":"ServerSettings_SettingsFooter__2Zy_g"};